import { useContext } from "react";
import { DataManRowContext } from "../defines";

export const useDataManRow = () => {
  const context = useContext(DataManRowContext);
  if (context === undefined) {
    throw new Error("useDataManRow must be used within a DataManRowProvider");
  }
  return context;
};
